import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Collection } from "@/components/Collection";
import { Craftsmanship } from "@/components/Craftsmanship";
import { WatchHistory } from "@/components/WatchHistory";
import { Testimonials } from "@/components/Testimonials";
import { Story } from "@/components/Story";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Collection />
        <Craftsmanship />
        <WatchHistory />
        <Testimonials />
        <Story />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
